import { ChainId } from '@src/configs/chainInfo'
import { getChecksumAddress } from '@src/utils'

/**
 * This is a list of token logos already included in the repo.
 * This list shall be removed if we implement an API endpoint to fetch logos.
 */
export const PUBLIC_STATIC_LOGOS: Readonly<Record<string, Record<string, string>>> = {
    ethereum: {
        '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48': '/assets/token/usdc.png',
        '0xdAC17F958D2ee523a2206206994597C13D831ec7': '/assets/token/usdt.png',
        '0x6B175474E89094C44Da98b954EedeAC495271d0F': '/assets/token/dai.png',
        '0x45804880De22913dAFE09f4980848ECE6EcbAf78': '/assets/token/paxg.png',
        '0x6c3ea9036406852006290770BEdFcAbA0e23A0e8': '/assets/token/pyusd.png',
        '0xbdC7c08592Ee4aa51D06C27Ee23D5087D65aDbcD': '/assets/token/usdl.png',
    },
    optimism: {
        '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85': '/assets/token/usdc.png',
        '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58': '/assets/token/usdt.png',
    },
    bsc: {
        '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d': '/assets/token/usdc.png',
        '0x55d398326f99059fF775485246999027B3197955': '/assets/token/usdt.png',
        '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3': '/assets/token/dai.png',
        '0xc5f0f7b66764F6ec8C8Dff7BA683102295E16409': '/assets/token/fdusd.png',
    },
    polygon: {
        '0x3c499c542cef5e3811e1192ce70d8cc03d5c3359': '/assets/token/usdc.png',
        '0xc2132D05D31c914a87C6611C10748AEb04B58e8F': '/assets/token/usdt.png',
        '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063': '/assets/token/dai.png',
    },
    arbitrum: {
        '0xaf88d065e77c8cC2239327C5EDb3A432268e5831': '/assets/token/usdc.png',
        '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1': '/assets/token/dai.png',
        '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9': '/assets/token/usdt.png',
        '0x7751E2F4b8ae93EF6B79d86419d42FE3295A4559': '/assets/token/wusdl.png',
    },
    avalanche: {
        '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E': '/assets/token/usdc.png',
        '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7': '/assets/token/usdt.png',
    },
    'Unknown Chain': {
        '0x7A4b79988DD55F10617e282B1B78C09580b36401': '/assets/token/usdc.png',
        '0x27268DCF77212Bdf02aE4FCc53e1EdAE81198970': '/assets/token/busd.png',
        '0x83A61AC43CE6C969ae188192a1a50F702F32Ded2': '/assets/token/fdusd.png',
        '0x753f2eD15Aec0c50BB604e683AE7C22C5D100Ff0': '/assets/token/usdt.png',
        '0x7b349E23AF221F5f001fB0bd6b0C7BF21a67069c': '/assets/token/usdc.png',
        '0xc1dC824F8Ac1a2FA30Fa867c7e83617b5961a2c9': '/assets/token/dai.png',
        '0xa185754635016BFd09E6E6D4109CC8155471a18a': '/assets/token/busd.png',
        '0x21f943a175E6e00375Df76eEcaac2DCD3fEcCd0A': '/assets/token/fdusd.png',
        '0xCECa2c8Cd6C25455AE68dc88458eBc12bBD7642d': '/assets/token/usdt.png',
        '0x66e12fa9EEd06d1fA79598dEE5F1a5f5b55A2624': '/assets/token/usdc.png',
        '0xAD3991701A210DAf65E3c10B7Aa073373ee71220': '/assets/token/dai.png',
        '0x963beD32634e1F2D9317245Fa096A179432fCD44': '/assets/token/busd.png',
        '0xB8c3c4fdd8bcc611351C430ee649A7f0c84AA5f8': '/assets/token/fdusd.png',
        '0xcFae58802D0Afa8dFd34aee1ee45d0845bc2963e': '/assets/token/usdt.png',
        '0xCc44A390b73898Bde54d11cdEb4eCB29c32ecFB2': '/assets/token/usdt.png',
        '0x33BDB14b22011edfaa7eCc390A4b2e30058Be18D': '/assets/token/usdc.png',
        '0x63E154468F297937D0Eb387031A6fC27729c2DDD': '/assets/token/busd.png',
        '0x823eB321355008D0b78fB43AFe09a1Af3b0CA7f2': '/assets/token/fdusd.png',
        '0x93AfE8E27DFF63d0d3d728fE7a0311AD00199A1e': '/assets/token/dai.png',
        '0xF4A78552E73eabF9FF0EdE4DB05d8fa2540536e3': '/assets/token/usdc.png',
        '0x84557523a32dF6eaC5537E9B9bC5172315a7E67f': '/assets/token/dai.png',
        '0xAeC9AF8e09F6920Ad6201F0231FD2CD6D6c08c01': '/assets/token/busd.png',
        '0x0E3B11112fDc8DdCd92b9C1EEB95851FE647Ce99': '/assets/token/fdusd.png',
        '0x2A06BF9bd68bb688239f95292D9104C4f3AB0e29': '/assets/token/usdt.png',
        '0x17dBF7f50ac72B89fa982114Ce7fA898a62c3462': '/assets/token/usdc.png',
        '0xf10A0CF749A9583cbBe41882C61B1219355591cd': '/assets/token/dai.png',
        '0x04722fE60c977aBf65F80816681a5d9D89a65420': '/assets/token/busd.png',
        '0x75b5Ba0e007A335f2fFc1A9418d1d5713ED12d71': '/assets/token/fdusd.png',
        '0x6419199ed66A8E6130D69f344542770E306ccC8d': '/assets/token/usdt.png',
    },
    blast: {
        '0x4300000000000000000000000000000000000003': '/assets/token/usdb.png',
    },
    celo: {
        '0xcebA9300f2b948710d2653dD7B07f33A8B32118C': '/assets/token/usdc.png',
        '0x48065fbBE25f71C9282ddf5e1cD6D6A887483D5e': '/assets/token/usdt.png',
    },
    opbnb: {
        '0x9e5aac1ba1a2e6aed6b32689dfcf62a509ca96f3': '/assets/token/usdt.png',
    },
    base: {
        '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913': '/assets/token/usdc.png',
        '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca': '/assets/token/usdc.png',
        '0x28bc44f9754f590da1564c1a7ba35f8e1d1b134a': '',
        '0x532f27101965dd16442e59d40670faf5ebb142e4': '/assets/token/brett.png',
        '0x0b3e328455c4059eeb9e3f84b5543f74e24e7e1b': '/assets/token/virtualsprotocol.png',
        '0x4ed4e862860bed51a9570b96d89af5e1b0efefed': '/assets/token/degen.png',
        '0x9a26f5433671751c3276a065f57e5a02d2817973': '/assets/token/keycat.png',
        '0x4f9fd6be4a90f2620860d680c0d4d5fb53d1a825': '/assets/token/aixbt.png',
        '0x1bc0c42215582d5a085795f4badbac3ff36d1bcb': '',
        '0x55cd6469f597452b5a7536e2cd98fde4c1247ee4': '/assets/token/luna.png',
        '0x1dd2d631c92b1acdfcdd51a0f7145a50130050c4': '/assets/token/alb.png',
        '0x52b492a33e447cdb854c7fc19f1e57e8bfa1777d': '/assets/token/pepe.png',
        '0x0db510e79909666d6dec7f5e49370838c16d950f': '/assets/token/anon.png',
        '0x0fd7a301b51d0a83fcaf6718628174d527b373b6': '',
        '0x0578d8a44db98b23bf096a382e016e29a5ce0ffe': '/assets/token/higher.png',
        '0x768be13e1680b5ebe0024c42c896e3db59ec0149': '/assets/token/ski.png',
        '0xff0c532fdb8cd566ae169c1cb157ff2bdc83e105': '',
        '0xac1bd2486aaf3b5c0fc3fd868558b082a531b2b4': '/assets/token/toshi.png',
        '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf': '/assets/token/cbbtc.png',
        '0x6b2504a03ca4d43d0d73776f6ad46dab2f2a4cfd': '',
        '0x36912b5cf63e509f18e53ac98b3012fa79e77bf5': '',
        '0x354d6890caa31a5e28b6059d46781f40880786a6': '',
        '0xfad8cb754230dbfd249db0e8eccb5142dd675a0d': '/assets/token/aerobud.png',
        '0x00dde4d2f08497bcec6f5e0666f63e14b3a1dab9': '',
        '0x3b18f2ec50719fd459e4234d16b38af74ab5ab7a': '',
        '0x3c4b6cd7874edc945797123fce2d9a871818524b': '/assets/token/paradox.png',
        '0xb488fcb23333e7baa28d1dfd7b69a5d3a8bfeb3a': '',
        '0x26e0331355df5ef082f69df161218093708a73ac': '',
        '0x092720239283a6da486feac3073476c37104603d': '',
    },
    unichain: {
        '0x078d782b760474a361dda0af3839290b0ef57ad6': '/assets/token/usdc.png',
    },
    sepolia: {
        '0x7b79995e5f793A07Bc00c21412e50Ecae098E7f9': '/assets/token/ethereum.png',
        '0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238': '/assets/token/usdc.png',
        '0xaA8E23Fb1079EA71e0a56F48a2aA51851D8433D0': '/assets/token/usdt.png',
    },
    monadtestnet: {
        '0x760AfE86e5de5fa0Ee542fc7B7B713e1c5425701': '/assets/token/mon.png',
        '0xB5a30b0FDc5EA94A52fDc42e3E9760Cb8449Fb37': '/assets/token/ethereum.png',
        '0xf817257fed379853cDe0fa4F97AB987181B1E5Ea': '/assets/token/usdc.png',
        '0x88b8E2161DEDC77EF4ab7585569D2415a1C1055D': '/assets/token/usdt.png',
        '0xfe140e1dCe99Be9F4F15d657CD9b7BF622270C50': '/assets/token/yaki.png',
        '0x0F0BDEbF0F83cD1EE3974779Bcb7315f9808c714': '/assets/token/dak.png',
        '0xE0590015A873bF326bd645c3E1266d4db41C4E6B': '/assets/token/chog.png',
    },
    megaethtestnet: {
        '0x10a6be7d23989d00d528e68cf8051d095f741145': '/assets/token/mega.png',
        '0x4eB2Bd7beE16F38B1F4A0A5796Fffd028b6040e9': '/assets/token/eth.png',
        '0x8D635c4702BA38b1F1735e8e784c7265Dcc0b623': '/assets/token/usdc.png',
        '0xFE928dD7D9cda6bcF7f2600B4A0e9726AE4d2577': '/assets/token/wbtc.png',
    },
}

// Used to support the limited token selection on testnets
export const HARDCODED_TESTNET_TOKEN_DATA: Record<string, Record<string, any>> = {
    sepolia: {
        chain_id: ChainId.Sepolia,
        native: {
            current_price: 2000, // Example price
            decimals: 18,
            price_change_24h: 25,
            price_change_percentage_24h: 1,
            market_cap: 300000000000,
        },
        assets: {
            '0x7b79995e5f793A07Bc00c21412e50Ecae098E7f9': {
                symbol: 'ETH',
                name: 'Ethereum',
                decimals: 18,
                current_price: 2000,
                price_change_24h: 25,
                price_change_percentage_24h: 1,
                market_cap: 300000000000,
                image: '/assets/token/eth.png',
            },
            '0x7169D38820dfd117C3FA1f22a697dBA58d90BA06': {
                symbol: 'USDT',
                name: 'Tether USD',
                decimals: 6,
                current_price: 1,
                price_change_24h: 0,
                price_change_percentage_24h: 0,
                market_cap: 100000000000,
                image: '/assets/token/usdt.png',
            },
        },
    },
    monadtestnet: {
        chain_id: ChainId.MonadTestnet,
        native: {
            current_price: 10, // Example price
            decimals: 18,
            price_change_24h: 0.5,
            price_change_percentage_24h: 5,
            market_cap: 1000000000,
        },
        assets: {
            '0x760AfE86e5de5fa0Ee542fc7B7B713e1c5425701': {
                symbol: 'MON',
                name: 'Monad',
                decimals: 18,
                current_price: 10,
                price_change_24h: 0.5,
                price_change_percentage_24h: 5,
                market_cap: 1000000000,
                image: '/assets/token/mon.png',
            },
            '0xf817257fed379853cDe0fa4F97AB987181B1E5Ea': {
                symbol: 'USDC',
                name: 'USD Coin',
                decimals: 6,
                current_price: 1,
                price_change_24h: 0,
                price_change_percentage_24h: 0,
                market_cap: 100000000000,
                image: '/assets/token/usdc.png',
            },
            '0x88b8E2161DEDC77EF4ab7585569D2415a1C1055D': {
                symbol: 'USDT',
                name: 'Tether USD',
                decimals: 6,
                current_price: 1,
                price_change_24h: 0,
                price_change_percentage_24h: 0,
                market_cap: 100000000000,
                image: '/assets/token/usdt.png',
            },
            '0xfe140e1dCe99Be9F4F15d657CD9b7BF622270C50': {
                symbol: 'YAKI',
                name: 'Moyaki',
                decimals: 18,
                current_price: 0.01,
                price_change_24h: 0,
                price_change_percentage_24h: 0,
                market_cap: 100000000000,
                image: '/assets/token/yaki.png',
            },
            '0x0F0BDEbF0F83cD1EE3974779Bcb7315f9808c714': {
                symbol: 'DAK',
                name: 'Molandak',
                decimals: 18,
                current_price: 0.01,
                price_change_24h: 0,
                price_change_percentage_24h: 0,
                market_cap: 100000000000,
                image: '/assets/token/dak.png',
            },
            '0xE0590015A873bF326bd645c3E1266d4db41C4E6B': {
                symbol: 'CHOG',
                name: 'Chog',
                decimals: 18,
                current_price: 0.01,
                price_change_24h: 0,
                price_change_percentage_24h: 0,
                market_cap: 100000000000,
                image: '/assets/token/chog.png',
            },
        },
    },
    megaethtestnet: {
        chain_id: ChainId.MegaEthTestnet,
        native: {
            current_price: 2000, // Example price
            decimals: 18,
            price_change_24h: 25,
            price_change_percentage_24h: 1,
            market_cap: 300000000000,
        },
        assets: {
            // '0x10a6be7d23989d00d528e68cf8051d095f741145': {
            //     symbol: 'MEGA',
            //     name: 'Mega',
            //     decimals: 18,
            //     current_price: 1,
            //     price_change_24h: 0,
            //     price_change_percentage_24h: 0,
            //     market_cap: 100000000000,
            //     image: '/assets/token/mega.png',
            // },
            [getChecksumAddress('0x4eB2Bd7beE16F38B1F4a0A5796Fffd028b6040e9')]: {
                symbol: 'WETH',
                name: 'Wrapped Ether',
                decimals: 18,
                current_price: 2000,
                price_change_24h: 25,
                price_change_percentage_24h: 1,
                market_cap: 300000000000,
                image: '/assets/token/eth.png',
            },
            '0x8D635c4702BA38b1F1735e8e784c7265Dcc0b623': {
                symbol: 'USDC',
                name: 'USD Coin',
                decimals: 6,
                current_price: 1,
                price_change_24h: 0,
                price_change_percentage_24h: 0,
                market_cap: 100000000000,
                image: '/assets/token/usdc.png',
            },
            // '0xFE928dD7D9cda6bcF7f2600B4A0e9726AE4d2577': {
            //     symbol: 'wBTC',
            //     name: 'Wrapped Bitcoin',
            //     decimals: 8,
            //     current_price: 100000,
            //     price_change_24h: 1000,
            //     price_change_percentage_24h: 1.5,
            //     market_cap: 1000000000000,
            //     image: '/assets/token/wbtc.png',
            // },
        },
    },
}
